<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from "@/components/template/pageTemplate";
import userPower from "@/mixin/userPower";
import api from "@/config/api";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      searchOptions: {
        simple: [
          {
            label: "",
            prop: "orderNo",
            type: "input",
            ifFuzzy: true,
            placeholder: "业务单号",
            align: "center",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            url: api.store.store,
          },
          {
            label: "审核状态：",
            prop: "reviewerStatus",
            type: "radio",
            span: 12,
            data: [
              { label: "未审核", value: 20 },
              { label: "已审核", value: 10 },
            ],
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.addGoods,
        },
        {
          label: "刷新",
          code: "refresh",
        },
        {
          label: "编辑",
          type: this.$utils.buttonType.tableOperate,
          code: "update",
          callback: this.toEditPage,
          filter: (data) => {
            return data.reviewerStatus == 10 ? false : true;
          },
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "业务单号",
            prop: "orderNo",
            width: "180",
            align: "center",
            showDetail: true,
          },
          {
            label: "门店名称",
            prop: "storeName",
            width: "80",
            align: "center",
          },
          {
            label: "单据金额",
            prop: "orderPrice",
            width: "80",
            align: "center",
          },
          {
            label: "审核状态",
            prop: "reviewerStatus",
            width: "80",
            align: "center",
            enumData: this.$utils.getCacheStatus("wgCleanOrder.reviewerStatus"),
          },
          {
            label: "申请人",
            prop: "voucherName",
            width: "80",
            align: "center",
          },
          {
            label: "申请时间",
            prop: "voucherDttm",
            width: "125",
            align: "center",
          },
          {
            label: "审核人",
            prop: "reviewerName",
            width: "80",
            align: "center",
          },
          {
            label: "审核时间",
            prop: "reviewerDttm",
            width: "125",
            align: "center",
          },
          { label: "备注", prop: "remarks", width: "80", align: "center" },
        ],
        url: api.weigh.cleanOrder,
      },
      // 详情
      detailColumns: {
        statusOption: {
          prop: "reviewerStatus",
          statusImg: {
            10: "/static/checked.png",
            20: "/static/un-check.png",
          },
          right: "350px",
          top: "30px",
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: "业务单号",
            prop: "orderNo",
            span: 12,
          },
          {
            label: "门店",
            prop: "storeId",
            url: api.system.seStore,
            span: 12,
          },
          {
            label: "原因",
            prop: "type",
            span: 12,
            enumData: this.$utils.getCacheStatus("wgCleanOrder.type"),
          },
          {
            label: "备注",
            prop: "remarks",
            span: 12,
          },
        ],
        tablesProp: {
          wgCleanOrderGoodsMapList: {
            tableName: "wgCleanOrderGoodsMapList",
            columns: [
              {
                label: "条码",
                prop: "barCode",
                width: "230",
                align: "center",
              },
              {
                label: "商品名称",
                prop: "goodsName",
                align: "center",
                width: "230",
              },
              {
                label: "单位",
                prop: "unitName",
                align: "center",
                width: "230",
              },
              {
                label: "进货规格",
                prop: "specs",
                align: "center",
                width: "210",
              },
              {
                label: "日清箱数",
                prop: "goodsNum",
                align: "center",
                width: "210",
              },
              {
                label: "日清数量",
                prop: "goodsBoxNum",
                align: "center",
                width: "110",
              },
              {
                label: "单价",
                prop: "purchasePrice",
                align: "center",
                width: "110",
              },
              {
                label: "系统库存",
                width: "110",
                align: "center",
                prop: "inventoryNum",
              },
              {
                label: "金额",
                prop: "cleanPrice",
                align: "center",
                width: "270",
              },
              {
                label: "零售价",
                prop: "retailPrice",
                align: "center",
                width: "270",
              },
              {
                label: "备注",
                prop: "remarks",
                align: "center",
                width: "270",
              },
            ],
          },
        },
        url: api.weigh.cleanOrder,
      },
    };
  },
  created() {
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
    this.setStore(this.searchOptions.complex);
    //this.setSupplier(this.searchOptions.complex);
  },
  methods: {
    toEditPage(row) {
      this.$router.push({ path: "/weigh/speciality/order/add?id=" + row.id });
    },
    addGoods() {
      this.$router.push({ path: "/weigh/speciality/order/add" });
    },
  },
};
</script>

<style scoped>
.page-content{
  background-color: #ffffff;
  height: calc(100vh - 60px);
}

.page-template{
  /*padding: 0px;*/
}

.page-content>>>.content-table-box{
  /*box-shadow:none;*/
  /*border-top:3px solid #e4e4e4;*/
}

.page-content>>>.menu-list{
  /*height: 62px;*/
  /*align-items: center;*/
  /*margin-bottom: 0px;*/
}

</style>



// WEBPACK FOOTER //
// src/page/weigh/speciality/Order.vue